import React, { useState } from "react";
import AditionalChatroomPlantilla from "./AditionalChatroomPlantilla";
import { plantillas, ChatSelect } from "./ChatRoom";
import AditionalChatroomCrm from "./AditionalChatroomCrm";

interface MediaFile {
    file: File;
    base64: string;
    name: string;
    caption: string;
}

interface Props {
    setModalPlantilla: React.Dispatch<React.SetStateAction<boolean>>;
    plantillas: plantillas[];
    setPlantillas: React.Dispatch<React.SetStateAction<plantillas[]>>;
    handleEditPlantilla: (id: number) => void;
    chatSelect: ChatSelect;
    isOpenModal: boolean;
    setVista: React.Dispatch<React.SetStateAction<string>>;
    selectedFiles: MediaFile[];
    setSelectedFiles: React.Dispatch<React.SetStateAction<MediaFile[]>>;
    nuevoMensaje: string;
    setNuevoMensaje: React.Dispatch<React.SetStateAction<string>>;
    setFileSeleccionadoIndex: React.Dispatch<
        React.SetStateAction<number | null>
    >;
}

const AditionalsChatroom = ({
    setModalPlantilla,
    setPlantillas,
    plantillas,
    handleEditPlantilla,
    chatSelect,
    isOpenModal,
    setVista,
    selectedFiles,
    setSelectedFiles,
    nuevoMensaje,
    setNuevoMensaje,
    setFileSeleccionadoIndex,
}: Props) => {
    const [isOpen, setIsOpen] = useState(isOpenModal);
    const [tab, setTab] = useState("");

    const handleTab = (tabParam: string) => {
        if (tab === tabParam) {
            setTab("");
            return;
        }

        setTab(tabParam);
    };

    return (
        <div
            className={`transition-all duration-300 ease-in-out overflow-hidden rounded-r-xl ${
                isOpen ? "w-full" : "w-16"
            } bg-gray-300 h-[75vh] flex flex-col `}
        >
            <div className="flex md:hidden justify-between items-center w-full mt-5 mb-5  ">
                <div
                    onClick={() => setVista("chatDetail")}
                    className="flex md:hidden mx-2 cursor-pointer hover:scale-105"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        className=" h-10 w-10 text-[#029BFC] "
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M15.75 19.5 8.25 12l7.5-7.5"
                        />
                    </svg>
                </div>
                <div
                    onClick={() => setIsOpen(!isOpen)}
                    className=" flex justify-center items-center cursor-pointer p-2"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className=" h-10 w-10 text-[#029BFC] "
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28Z"
                        />
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                        />
                    </svg>
                </div>
            </div>
            <div
                onClick={() => setIsOpen(!isOpen)}
                className="w-full hidden md:flex justify-end items-center cursor-pointer p-2"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className=" h-10 w-10 text-[#029BFC] "
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28Z"
                    />
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                    />
                </svg>
            </div>
            {isOpen && (
                <div className="flex justify-center items-center gap-3">
                    <div
                        onClick={() => handleTab("crm")}
                        className={` ${
                            tab === "crm"
                                ? " bg-[#029BFC] text-white "
                                : "bg-gray-400"
                        } p-2 cursor-pointer rounded-xl`}
                    >
                        CRM
                    </div>
                    <div
                        onClick={() => handleTab("plantilla")}
                        className={` ${
                            tab === "plantilla"
                                ? " bg-[#029BFC] text-white "
                                : "bg-gray-400"
                        } p-2 cursor-pointer rounded-xl`}
                    >
                        Plantillas
                    </div>
                </div>
            )}

            {tab === "plantilla" && (
                <AditionalChatroomPlantilla
                    setModalPlantilla={setModalPlantilla}
                    plantillas={plantillas}
                    setPlantillas={setPlantillas}
                    handleEditPlantilla={handleEditPlantilla}
                    selectedFiles={selectedFiles}
                    setSelectedFiles={setSelectedFiles}
                    nuevoMensaje={nuevoMensaje}
                    setNuevoMensaje={setNuevoMensaje}
                    setFileSeleccionadoIndex={setFileSeleccionadoIndex}
                />
            )}

            {tab === "crm" && <AditionalChatroomCrm chatSelect={chatSelect} />}
        </div>
    );
};

export default AditionalsChatroom;
